/**
 * @voltxampere/ui — 5-pin DIN connector (Sprint 50-8)
 *
 * 5-pin DIN-41524 connector — legacy audio MIDI standard, vintage
 * computer audio (Atari ST, Commodore 64), MIDI input/output on
 * synthesizers and audio interfaces.
 *
 * Pinout (180° round, looking at female socket):
 *   1 — left audio
 *   2 — ground/shield
 *   3 — right audio
 *   4 — N/C (or +5V on some MIDI variants)
 *   5 — N/C
 *
 * Reference: DIN 41524 (Deutsches Institut für Normung).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`
 * (passive connector breakout, no MNA contribution).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const connectorDin5pin = {
    id: "din-5pin",
    nameTr: "5-Pin DIN Konektör (audio/MIDI)",
    nameEn: "5-Pin DIN Connector (audio/MIDI)",
    shortcut: "J",
    category: "connector",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "J",
    defaultValue: "DIN-5",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 0,
        busType: "audio-midi-din",
        pinCount: 5,
        standard: "DIN 41524",
        pinout: {
            "1": "Audio_L",
            "2": "GND",
            "3": "Audio_R",
            "4": "NC",
            "5": "NC",
        },
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=connector-din-5pin.js.map